import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { SensorTypeEnum } from '@zaoblako/shared/modules/traffic/enums/sensor.type.enum';
import { SensorTypeEnumI18n } from '@zaoblako/shared/modules/traffic/i18n/sensor-type-enum.i18n';

@Pipe({
  name: 'sensorTypeName',
  standalone: true
})
export class SensorTypeNamePipe implements PipeTransform {
  public transform(type: SensorTypeEnum): string {
    return SensorTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
